import React from 'react';

const TranslationFilters = ({ translations, selectedTranslations, onFilterChange, onClose }) => {
  const currentResearchers = [...new Set(translations.map(t => t.researcher_name))];
  
  // Get unique researchers with their language
  const researchersWithLanguage = {};
  translations.forEach(t => {
    if (!researchersWithLanguage[t.researcher_name]) {
      researchersWithLanguage[t.researcher_name] = t.language;
    }
  });

  // Create a color palette for researchers
  const colors = [
    '#007bff', '#28a745', '#dc3545', '#ffc107', '#17a2b8',
    '#6f42c1', '#e83e8c', '#fd7e14', '#20c997', '#6610f2',
    '#d63384', '#0d6efd', '#198754', '#ff0000', '#00ff00',
    '#0000ff', '#ffff00', '#ff00ff', '#00ffff', '#800000'
  ];

  // Create a mapping of researcher names to colors (sorted alphabetically for consistency)
  const sortedResearchers = [...currentResearchers].sort();
  const researcherToColor = {};
  sortedResearchers.forEach((name, idx) => {
    researcherToColor[name] = colors[idx % colors.length];
  });

  // Separate Punjabi and English researchers
  const punjabiResearchers = currentResearchers.filter(name => 
    researchersWithLanguage[name]?.toLowerCase() === 'punjabi'
  );
  const englishResearchers = currentResearchers.filter(name => 
    researchersWithLanguage[name]?.toLowerCase() === 'english'
  );
  
  const handleSelectAll = () => {
    // Select all current researchers
    currentResearchers.forEach(name => {
      if (!selectedTranslations.includes(name)) {
        onFilterChange(name);
      }
    });
  };

  const handleDeselectAll = () => {
    // Deselect all current researchers
    currentResearchers.forEach(name => {
      if (selectedTranslations.includes(name)) {
        onFilterChange(name);
      }
    });
  };

  return (
    <div style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#f9f9f9', position: 'relative' }}>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            background: 'none',
            border: '1px solid #000',
            fontSize: '20px',
            cursor: 'pointer',
            color: '#666',
            padding: '4px',
            lineHeight: '1',
            width: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '4px',
            transition: 'background-color 0.2s ease, color 0.2s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#e0e0e0';
            e.target.style.color = '#333';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = '#666';
          }}
          title="Close"
        >
          ×
        </button>
      )}
      
      {currentResearchers.length > 0 && (
        <div style={{ marginBottom: '15px', textAlign: 'center', display: 'flex', gap: '8px', justifyContent: 'center' }}>
          <button
            onClick={handleSelectAll}
            style={{
              padding: '6px 12px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '11px',
              fontWeight: '500',
              transition: 'background-color 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#218838';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#28a745';
            }}
          >
            Select All
          </button>
          <button
            onClick={handleDeselectAll}
            style={{
              padding: '6px 12px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '11px',
              fontWeight: '500',
              transition: 'background-color 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#c82333';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#dc3545';
            }}
          >
            Deselect All
          </button>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {punjabiResearchers.length > 0 && (
          <div>
            <div style={{ fontWeight: 'bold', marginBottom: '6px', fontSize: '13px' }}>Punjabi Translators:</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              {punjabiResearchers.map((name, idx) => (
                <label key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontWeight: 'normal', fontSize: '12px', marginBottom: 0 }}>
                  <input
                    type="checkbox"
                    checked={selectedTranslations.includes(name)}
                    onChange={() => onFilterChange(name)}
                  />
                  <span style={{ 
                    display: 'inline-block', 
                    width: '12px', 
                    height: '12px', 
                    borderRadius: '50%', 
                    backgroundColor: researcherToColor[name],
                    marginRight: '6px',
                    verticalAlign: 'middle'
                  }}></span>
                  {name}
                </label>
              ))}
            </div>
          </div>
        )}

        {englishResearchers.length > 0 && (
          <div>
            <div style={{ fontWeight: 'bold', marginBottom: '6px', fontSize: '13px' }}>English Translators:</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              {englishResearchers.map((name, idx) => (
                <label key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontWeight: 'normal', fontSize: '12px', marginBottom: 0 }}>
                  <input
                    type="checkbox"
                    checked={selectedTranslations.includes(name)}
                    onChange={() => onFilterChange(name)}
                  />
                  <span style={{ 
                    display: 'inline-block', 
                    width: '12px', 
                    height: '12px', 
                    borderRadius: '50%', 
                    backgroundColor: researcherToColor[name],
                    marginRight: '6px',
                    verticalAlign: 'middle'
                  }}></span>
                  {name}
                </label>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TranslationFilters;
